import { createAction, handleActions } from 'redux-actions';

// ACTION CREATORS
export const setRateError = createAction('SET_RATE_ERROR');

// REDUCERS
export const reducer = handleActions(
  new Map([
    [
      setRateError,
      (state, action) => {
        return {...state, ...action.payload}
      } 
    ]
  ]),
  {viewed: true} 
);

// SELECTORS
export const getError = state => state.rateError;
 
